import 'firebase/firestore'
import 'firebase/auth'
import {
	db
} from '../resources/firebase'
import {
	sendNotification
} from './notifications'

/**
 * Get a user's group
 * @param {String} groupID Group ID to query by
 * @returns {Object} Object containing data on group
 */
export function getGroup(groupID) {
	const groupData = new Promise((resolve, reject) => {
		db.collection("test_groups").doc(groupID)
			.get()
			.then((doc) => {
				if (doc.exists) {
					resolve(doc.data())
				}
			})
			.catch((error) => {
				// console.log(error)
				reject(new Error(error))
			})
	})

	return groupData
}

/**
 * Update group admin
 * @param {Array} groups - Array of groups we want to update
 * @param {String} userID - Soon to be former Admin's user id
 */
export function updateGroupAdmin(groups, userID) {
	return new Promise((resolve, reject) => {
		groups.forEach(group => {
			db.collection("test_groups").doc(group)
				.get()
				.then((doc) => {
					if (doc.data().admin === userID) {
						let newAdmin = doc.data().members.find(member => member !== userID)

						if (typeof (newAdmin) === 'string') {
							db.collection("test_groups").doc(group).update({
									"admin": newAdmin
								})
								.then(() => {
									//Add to new admin's notifications
									let notification = {
										type: 'group-admin-change',
										user: userID,
										dateCreated: Date.now(),
										members: doc.data().members.length >= 6 ?
											doc.data().groupName : doc.data().members,
										group: doc.data().groupID,
										seen: false
									}

									sendNotification(newAdmin, notification)
									resolve()
								})
								.catch((error) => {
									// console.log(error)
									reject(new Error(error))
								})
						}
					}
				})
		})
	})
}



// WEBPACK FOOTER //
// ./src/api/groups.js